import { forwardRef, useContext } from "react";

import { RadioPill, RadioPillProps } from "emoreg/molecules/radio";

import { GroupedRadioContext } from "../context";

export type RadioPillItemProps = Omit<
  Omit<RadioPillProps<string>, "value">,
  "checked" | "id" | "hasError" | "error" | "aria-labelledby" | "onChange" | "name"
> & { value: string };

export const RadioPillItem = forwardRef<HTMLInputElement, RadioPillItemProps>(
  ({ value, ...props }, ref) => {
    const ctx = useContext(GroupedRadioContext);

    return (
      <RadioPill
        {...props}
        ref={ref}
        name={ctx.name}
        id={`${ctx.name}_${value}`}
        hasError={ctx.hasError}
        value={value}
        checked={ctx.value === value}
        aria-labelledby={ctx["aria-labelledby"]}
        onChange={ctx.onChange}
      />
    );
  }
);
